<template>
  <div class="navbar-wrapper" id="tsection">
    <transition name="fade">
    <div class="active-nav" v-if="toggle">
      <div class="link shorthand">
        <div class="small-div"
          v-for="(nav, index) in navItems"
          :key="nav.name">
          <a class="div-link" :href="nav.path">
            {{ nav.label }}
          </a>
        </div>
        <div class="small-div white">
          <div>
            <img src="../assets/logo-text.svg" class="img-responsive" style="width:100%;" />
            <br />
            <div class="font-bold" v-if="phone && fax" style="padding:0;margin-top:20px;font-size:1.2em;">
              Call: {{ phone }}&nbsp;&nbsp;&nbsp;Fax: {{ fax }}
            </div>
            <div class="" v-if="address" style="padding:0;margin-top:6px;font-size:1.2em;font-weight:normal;line-height:1.4em;">
              {{ address }}
            </div>
          </div>
        </div>
        <!-- <div class="small-div">
          <div class="eicon">
            <a href="https://www.facebook.com/cms" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
            <a href="https://www.youtube.com/channel/cms" target="_blank"><i class="fa fa-youtube" aria-hidden="true"></i></a>
            <a href="https://www.instagram.com/cms" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
            <a href="http://clientmanagementprobation.com" target="_blank" v-if="false"><i class="fa fa-link" aria-hidden="true"></i></a>
          </div>
        </div> -->
      </div>
    </div>
    </transition>
    <div class="full-layer">
      <navbar-full :toggle="toggle" @onToggle="toggle = $event"></navbar-full>
    </div>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import NavbarFull from './NavBarFull.vue'
import Site from '@/apis/Site'

export default {
  name: 'topsection',
  components: {
    'NavbarFull': NavbarFull
  },
  data () {
    return {
      toggle: false,
      navItems: EventBus.getNav(),
      phone: undefined,
      fax: undefined,
      address: undefined
    }
  },
  watch: {
    toggle: function (val) {
      // console.log('toggle changed to: ' + val)
    }
  },
  async mounted () {
    try {
      let data
      data = await Site.infoNamed('navbar-phone')
      if (data && data[0] && data[0].content) {
        this.phone = data[0].content
      } else {
        this.phone = undefined
      }
      data = await Site.infoNamed('navbar-fax')
      if (data && data[0] && data[0].content) {
        this.fax = data[0].content
      } else {
        this.fax = undefined
      }
      data = await Site.infoNamed('navbar-address')
      if (data && data[0] && data[0].content) {
        this.address = data[0].content
      } else {
        this.address = undefined
      }
    } catch (error) {
      this.phone = undefined
      this.fax = undefined
      this.address = undefined
      console.log('info error', error)
    }
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.toggle = !this.toggle
        var root = document.documentElement
        root.className = ''

        // this.$scrollTo(el)
        this.$scrollTo('#' + target, { offset: -50 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/app_setting.scss";
@import "./NavbarSettings.scss";

.topsection {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.topsection {
  min-height: 250px;
  width: 100%;
  height: auto;
  position: relative;
  background: transparent;
  margin-top: 50px;

  @media screen and (min-width: $desktop) {
    margin-top: 0;
  }
  & .ccontainer {
    max-width: 1152px !important;
    z-index: 1;
  }
}

$color-yellow: #FEC624;
$widescreen: 1200px;

#tsection {
  // this to workaround top bar positioning
  z-index: 20;
  width: 100%;
  @if $navbar-type == overlay {
    position: absolute;
  } @else if $navbar-type == top {
    position: relative;
    height: $navbar-height !important;
    @media screen and (max-width: ($tablet - 1)) {
      height: $navbar-height-mobile;
    }
  } @else {
    @error "Invalid navbar type"
  }
  right: 0;
  top: 0;
  // this to workaround top bar positioning

  // min-height: 100vh;

  // 100% height, non scrollable full screen mode ------------------------
  .active-nav {
    @if $navbar-mobile-type == fullscreen {
      display: flex;
    } @else {
      display: block;
    }
    @if $navbar-mobile-type == scrollable {
      padding-top: $navbar-height-mobile + 20px;
      height: 200px;
      overflow-y: scroll;
    }
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.9);
    z-index: 10;
    line-height: 1;
    vertical-align: middle;
    justify-content: center;
    align-items: center;

    @if $navbar-mobile-type == fullscreen {
      // landscape mobile
      @media (min-width: 480px) and (max-height: 420px) {
        padding-top: 2em;
      }
    }

    & .link a {
      color: $color-primary-yellow;
      font-size: 1.2em;
      display: block;

      @if $navbar-mobile-type == fullscreen {
        margin-bottom: 0rem;

        @media screen and (min-width: $tablet) {
          margin-bottom: 1rem;
        }

        @media screen and (min-width: $desktop) {
          margin-bottom: 1rem;
        }
        // potrait
        @media (max-width: 420px) and (min-height: 480px) {
          margin-bottom: 1rem;

          // extra mini
          @media (max-width: 320px) {
            margin-bottom: 0rem;
          }
        }
        // landscape mobile
        @media (min-width: 480px) and (max-height: 420px) {
          margin-bottom: 1rem;
        }
      }

      &:before {
        background-color: $color-white;
      }
      &:hover {
        color: $color-white;
      }
    }
    & .link {
      @if $navbar-mobile-type == fullscreen {
        display: flex;
      } @else {
        display: block;
      }
      flex-direction: column;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      height: 100%;

      &.shorthand {
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-flex-direction: row;
        flex-direction: row;
        @if $navbar-mobile-type == fullscreen {
          height: 50%;
        }

        & .small-div {
          width: 100%;
          text-align: center;
          @if $navbar-mobile-type == scrollable {
            padding: 12px;
            color: $color-primary-yellow;
            background-color: $color-primary-blue;
            &.white {
              color: black;
              background-color: white;
            }
            border: 1px solid white;
          }

          // potrait
          @media (max-width: 420px) and (min-height: 480px) {
            @if $navbar-mobile-type == fullscreen {
              width: 100%;
            }
          }
          // landscape mobile
          @media (min-width: 480px) and (max-height: 420px) {
            @if $navbar-mobile-type == fullscreen {
              width: 50%;
            }
          }

          & div,
          & .div-link {
            display: inline-block;
            font-family: $font-family;
            font-weight: bold;
            text-transform: uppercase;
            text-align: left;
            width: 100%;
            padding: 0.5rem;
            padding-left: 30px;
            padding-right: 30px;
          }
          @if $navbar-mobile-type == fullscreen {
            &:first-child {
              // @media screen and (min-height: 601px) {
              margin-top: 2rem;

              @media screen and (min-width: $tablet) {
                margin-top: 2rem;
              }
              // potrait
              @media (max-width: 420px) and (min-height: 480px) {
                margin-top: 2rem;
              }
              // landscape mobile
              @media (min-width: 480px) and (max-height: 420px) {
                margin-top: 0rem;
              }
            }
            // &:nth-child(4) {
            //   margin-top: 2em;
            //   @media (min-width: 480px) and (max-height: 420px) {
            //     margin-top: 0rem;
            //   }
            // }
          }
        }
      }
    }
    & .link .elink {
      &:before {
        background-color: $color-red;
      }
      &:hover {
        color: $color-gray-light;
      }
    }
    & .link .eicon {
      // custom for iphone 4 and 5
      & a {
        display: inline-block;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        &:before {
          height: 0;
        }
      }
      & i {
        font-size: 2rem;
        // width: 50px;
        // height: 50px;
        vertical-align: middle;
      }
    }
  }

  & .logo {
    padding: 0 30px;
    @media screen and (min-width: $desktop) {
      padding: 0;
    }
  }
  & .sub {
    padding: 30px 30px;
    @media screen and (min-width: $tablet) {
      padding-top: 50px;
      padding-left: 60px;
      padding-right: 60px;
    }
    @media screen and (min-width: $desktop) {
      padding-top: 50px;
      padding-left: 30px;
      padding-right: 30px;
    }
    @media screen and (min-width: $widescreen) {
      padding-top: 70px;
    }
  }
}

.full-layer {
  // min-height: 100vh;
  /*height: 100px;*/
  display: flex;
  flex-direction: column;

  // html.modal-open & {
  //   // this to remove scrollability
  //   pointer-events: none;
  // }
}
@media screen and (min-width: 1008px) {
  .topsection {
    min-height: calc(100vh - 135px);
  }
}
</style>



// WEBPACK FOOTER //
// NavBarOverlay.vue?e757ec98